import React from 'react'
import { Col, Dialog, InputField, Row, SelectField } from '../../../../ppui'
import { STATUTORY_KYC_CONST } from '../statutory-kyc-const'

const BankUpdateModal = ({
    bankmodal,
    ToggleBank,
    UpdateStatutory,
    bankdetails,
    onChangeBank,
    // OnBlureBank,
    errorBank,
    updateLoder
}) => {
  return (
     <Dialog
            title="Employee Bank Details"
            closeButton={true}
            fullWidth
            maxWidth="xs"
            open={bankmodal}
            onClose={ToggleBank}
            onSubmit={UpdateStatutory}
           btnLoading={updateLoder}
           bodyScroll={true}
          >

 <Row rowGap>
        <Col sm={12}>
          <InputField
            error={!!errorBank?.bank_name}
            helperText={errorBank?.bank_name}
            valueSinc={!!bankdetails?.bank_name}
            value={bankdetails?.bank_name}
            onChange={(e) => onChangeBank(e, "bank_name")}
            // onBlur={(e) => OnBlureBank(e, "bank_name")}
            {...STATUTORY_KYC_CONST.bank_name}
          />
        </Col>
        <Col sm={12}>
          <InputField
            error={!!errorBank?.branch_name}
            helperText={errorBank?.branch_name}
            valueSinc={!!bankdetails?.branch_name}
            value={bankdetails?.branch_name}
            onChange={(e) => onChangeBank(e, "branch_name")}
            // onBlur={(e) => OnBlureBank(e, "branch_name")}
            {...STATUTORY_KYC_CONST.branch_name}
          />
        </Col>
        <Col sm={12}>
          <InputField
            error={!!errorBank?.account_number}
            helperText={errorBank?.account_number}
            valueSinc={!!bankdetails?.account_number}
            value={bankdetails?.account_number}
            onChange={(e) => onChangeBank(e, "account_number")}
            // onBlur={(e) => OnBlureBank(e, "account_number")}
            {...STATUTORY_KYC_CONST.account_number}
          />
        </Col>

        <Col sm={12}>
          <InputField
            error={!!errorBank?.ifsc_code}
            helperText={errorBank?.ifsc_code}
            valueSinc={!!bankdetails?.ifsc_code}
            value={bankdetails?.ifsc_code}
            onChange={(e) => onChangeBank(e, "ifsc_code")}
            // onBlur={(e) => OnBlureBank(e, "ifsc_code")}
            {...STATUTORY_KYC_CONST.ifsc_code}
          />
        </Col>
        <Col sm={12}>
          <SelectField
            error={!!errorBank?.payment_through}
            helperText={errorBank?.payment_through}
            valueSinc={!!bankdetails?.payment_through}
            defaultValue={bankdetails?.payment_through}
            onChange={(e) => onChangeBank(e, "payment_through")}
            // onBlur={(e) => OnBlureEPF(e, "member_payroll")}
            {...STATUTORY_KYC_CONST.payment_through}
          />
        </Col>

      </Row>
          </Dialog>
  )
}

export default BankUpdateModal